import {HYGRAPH_PREVIEW_ROLES} from "@shared/consts/hygraph-preview";
import {User} from "@app/auth";

export const isUserAllowedToPreviewHygraph = ({ rolesAsSet = [] }: User): boolean => {
  return HYGRAPH_PREVIEW_ROLES.some(role => rolesAsSet.includes(role));
}
